import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { Service, Slot, Appointment } from './appointment.models';
import { Customer } from '@models';

export const BookingScheduleAppointmentActions = createActionGroup({
  source: 'Booking Schedule Appointment',
  events: {
    'Load Available Slots': emptyProps(),
    'Set Default Employee': props<{ checkedServices: Array<string> }>(),
    'Update Selected Employees': emptyProps(),
    'Select Employee': props<{ serviceUuid: string; employeeUuid: string }>(),
    'Set Date': props<{ date: string }>(),
    'Check Available Slot': props<{ slot: string }>(),
    'Clear Available Slot': emptyProps(),
    'Component Loaded': emptyProps(),
    'Create Draft Appointment': emptyProps(),
  },
});

export const BookingConfirmAppointmentActions = createActionGroup({
  source: 'Booking Confirm Appointment',
  events: {
    'Delete Draft Appointment': emptyProps(),
    'Activate Appointment': props<{ payload: Customer }>(),
    'Set External Note': props<{ externalNote: string }>(),
  },
});

export const BookingScheduleAppointmentApiActions = createActionGroup({
  source: 'Booking Schedule Appointment API',
  events: {
    'Load Slots Success': props<{ services: Array<Service>; slots: Array<Slot> }>(),
    'Load Slots Failure': emptyProps(),
    'Create Draft Appointment Success': props<{ appointment: Appointment }>(),
    'Create Draft Appointment Failure': emptyProps(),
  },
});

export const BookingAppointmentActions = createActionGroup({
  source: 'Booking Appointment',
  events: {
    'Load Appointment': emptyProps(),
  },
});

export const BookingAppointmentApiActions = createActionGroup({
  source: 'Booking Appointment API',
  events: {
    'Load Appointment Success': props<{ appointment: Appointment }>(),
    'Load Appointment Failure': emptyProps(),
  },
});

export const BookingConfirmAppointmentApiActions = createActionGroup({
  source: 'Booking Confirm Appointment API',
  events: {
    'Activate Appointment Success': props<{ appointment: Appointment }>(),
    'Activate Appointment Failure': emptyProps(),
    'Delete Appointment Success': emptyProps(),
    'Delete Appointment Failure': emptyProps(),
  },
});
